import type { VacancyBucket } from '@/Network/Types/Responses/VacancyCenterResponses'

/** Vaga aberta (sem médico): as mesmas cores da Matriz. */
export const VACANCY_OPEN_COLOR = '#F18F1B'
export const VACANCY_OPEN_BG = '#FEF3E7'

/** Aguardando confirmação do médico. */
export const VACANCY_AWAITING_COLOR = '#6D4FC2'
export const VACANCY_AWAITING_BG = '#EFEAFB'

/** Contagem regressiva abaixo de 6 h. */
export const VACANCY_URGENT_COLOR = '#DA1E28'

/** Colunas do kanban / grupos da lista por urgência. */
export const VACANCY_BUCKET_COLORS: Record<VacancyBucket, string> = {
  next6h: '#DA1E28',
  today: '#F18F1B',
  tomorrow: '#F1C21B',
  week: '#84C8D7'
}

/** Cor dos grupos por setor/unidade (primária do painel). */
export const VACANCY_GROUP_COLOR = '#2F7F91'

/** Desktop (kanban) a partir de 1024px; abaixo, lista. */
export const VACANCY_DESKTOP_MEDIA_QUERY = '(min-width: 1024px)'
